import { MIME_TYPES } from '@picsio/db/src/constants';
import {
  AdobeIllustrator,
  AdobeInDesign,
  AdobePhotoshop,
  AdobeCreativeCloud,
  Google,
  Wordpress,
  AdobePremierePro,
  AdobeAfterEffects,
} from '@picsio/icons';

export const INTEGRATION_META = {
  illustrator: {
    href: 'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
    IntegrationIcon: AdobeIllustrator,
    tooltipKey: 'ADOBE_ILLUSTRATOR',
    testId: 'adobe-illustrator-icon',
  },
  indesign: {
    href: 'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
    IntegrationIcon: AdobeInDesign,
    tooltipKey: 'ADOBE_INDESIGN',
    testId: 'adobe-indesign-icon',
  },
  photoshop: {
    href: 'https://exchange.adobe.com/apps/cc/bcd6e7f2/picsio-digital-asset-management-uxp',
    IntegrationIcon: AdobePhotoshop,
    tooltipKey: 'ADOBE_PHOTOSHOP',
    testId: 'adobe-photoshop-icon',
  },
  creativeCloud: {
    href: 'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
    IntegrationIcon: AdobeCreativeCloud,
    tooltipKey: 'ADOBE_CREATIVE_CLOUD',
    testId: 'adobe-creative-cloud-icon',
  },
  google: {
    href: 'https://workspace.google.com/marketplace/search/pics.io',
    IntegrationIcon: Google,
    tooltipKey: 'GOOGLE_WORKSPACE',
    testId: 'google-workspace-icon',
  },
  wordpress: {
    href: 'https://wordpress.org/plugins/pics-io/',
    IntegrationIcon: Wordpress,
    tooltipKey: 'WORDPRESS',
    testId: 'wordpress-icon',
  },
  premierePro: {
    href: 'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
    IntegrationIcon: AdobePremierePro,
    tooltipKey: 'ADOBE_PREMIERE',
    testId: 'adobe-premiere-icon',
  },
  afterEffects: {
    href: 'https://exchange.adobe.com/apps/cc/101726/picsio-digital-asset-management',
    IntegrationIcon: AdobeAfterEffects,
    tooltipKey: 'ADOBE_AFTER_EFFECTS',
    testId: 'adobe-after-effects-icon',
  },
};

const indesignMimeTypes = [
  'application/x-indesign',
  'application/x-indesign-interchange',
  'application/vnd.adobe.indesign-idml-package',
];

const checkAndSetAssetAvailableIntegrations = (asset) => {
  const integrations = [];

  if (indesignMimeTypes.includes(asset.mimeType)) {
    integrations.push('indesign');
  }

  if (MIME_TYPES.psd.includes(asset.mimeType) || asset.mimeType === 'application/vnd.3gpp.pic-bw-small') {
    integrations.push('photoshop', 'illustrator');
  }

  if (asset.mimeType === 'application/postscript') {
    integrations.push('illustrator', 'photoshop', 'indesign');
  }

  const excludeImageMimeTypes = [
    'application/postscript',
    ...indesignMimeTypes,
    ...MIME_TYPES.psd,
    ...MIME_TYPES.raw,
  ];

  if (asset.mimeType.startsWith('image/') && !excludeImageMimeTypes.includes(asset.mimeType)) {
    integrations.push('creativeCloud', 'google', 'wordpress');
  }

  if (asset.mimeType.startsWith('audio/') || asset.mimeType.startsWith('video/') || MIME_TYPES.video.includes(asset.mimeType)) {
    integrations.push('premierePro', 'afterEffects', 'wordpress');
  }

  if (MIME_TYPES.pdf.includes(asset.mimeType) || MIME_TYPES.text.includes(asset.mimeType) || MIME_TYPES.office.includes(asset.mimeType)) {
    integrations.push('google');
  }

  if (MIME_TYPES.raw.includes(asset.mimeType)) {
    integrations.push('photoshop');
  }

  return Array.from(new Set(integrations));
};

export default checkAndSetAssetAvailableIntegrations;
